import { RecommendationsState } from '../../../models';
import { DeepPartial } from '../../../utils';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class ReplaceStateMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.replaceState]: (recommendationsState: RecommendationsState,
      newRecommendationsState: DeepPartial<RecommendationsState>) => {
      Object.assign(recommendationsState, newRecommendationsState);
    }
  };
}
